import {ChangeDetectionStrategy, Component, model, ModelSignal, OnDestroy, OnInit, OutputRefSubscription} from '@angular/core';
import { MenuCommonComponent } from '@app/shared/menu-common/menu-common.component';

import {MatCardModule} from '@angular/material/card';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {provideNativeDateAdapter} from '@angular/material/core';

import { LogisticService } from '../logistic.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SpinnerService } from '@app/shared/spinner.service';
import { AlertService } from '@app/shared/alert.service';
import { CardLivraisonComponent } from './card-livraison/card-livraison.component';


@Component({
    selector: 'app-planning',
    imports: [MenuCommonComponent, MatCardModule, MatDatepickerModule, CardLivraisonComponent],
    templateUrl: './planning_old.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './planning_old.component.scss'
})
export class PlanningComponent_Old implements OnInit , OnDestroy {
eval = eval ; 
  // dateSelected! : ModelSignal<Date> ;
  public dateSelected = model<Date>(new Date());
  public orders: any;
  private souscriptionDateChange!: OutputRefSubscription;
  // orders = 

    constructor(private logisticService: LogisticService, private router: Router, private route: ActivatedRoute, private spinner: SpinnerService, private alertService: AlertService) { }
    ngOnInit(): void {
      this.souscriptionDateChange =  this.dateSelected.subscribe((date : Date) =>{
        // console.log('date',date);
        this.getOrders(date)
      })
      this.dateSelected.set(new Date());
    }
    
    
    getOrders(date : Date): void {
      this.logisticService.getPlanedDeliveriesByDate(date)
      .subscribe({
        next: (orders: any) => {
          // console.log('items',orders);
          this.orders = orders
        },
        error: (e) => {
          console.log("ERREUR Serveur : ", e.error);
          this.spinner.hide();
          this.alertService.error("ERREUR Serveur : " + e.error);	
        }});
      }
      
      
      
      
      ngOnDestroy(): void {
        this.souscriptionDateChange.unsubscribe();
      }
}
